(function () {
   $(document).ready(function() {
        $('.image-with-text__content .read-more').click(function(e) {
            e.preventDefault();
            var moreText = $(this).prev('.more-text');
            var showLess = $(this).next('.show-less');
              moreText.slideDown();
             $(this).hide();
               $(showLess).show();
         
        });
      $('.image-with-text__content .show-less').click(function(e) {
            e.preventDefault();
            var moreText = $('.image-with-text__content .more-text');
            var readMore = $(this).prev('.show-less');
              moreText.slideUp();
               $(this).hide();
             $(readMore).show();
         
        });
    });
	const stopVideo = (section) => {
		const videos = section.querySelectorAll("video");

		if (videos.length > 0) {
			videos.forEach((video) => {
				video.pause();
			});
		}
	};

	const playVideo = (section) => {
		const videos = section.querySelectorAll("video");

		if (videos.length > 0) {
			videos.forEach((video) => {
				video.play();
			});
		}
	};

	const initSection = () => {
		const sections = document.querySelectorAll(".image-with-text-section");

		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) playVideo(entry.target);
				else stopVideo(entry.target);
			});
		});

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			playVideo(entry.target);
		});

		sections.forEach((section) => {
			sectionObserver.observe(section);
			sectionResizeObserver.observe(section);
		});
	};

	initSection();

	document.addEventListener("shopify:section:load", function () {
		initSection();
	});
})();
